import React, { useEffect, useState } from "react";
import * as MyCells from '../../../../utils/Cells';

const TaxAggregatePanel = (props) => {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        setRows(props.rows);
    }, [props]);

    function getSize() {
        return rows.length;
    }

    function getAmount() {
        return rows.reduce((a, b) => a + (b.original.amount || 0), 0)
    }

    return (
        <div className="aggregate-data">
            <span>Sorok száma: {getSize()}</span>
            <span> Összeg: {<MyCells.NumberCell value={getAmount()} />}</span>
        </div>
    );
};

export default TaxAggregatePanel;